<template>
  <b-modal :id="modalId" hide-footer no-close-on-backdrop size="lg">
    <div class="privacy-modal-card">
      <privacy-notice />
    </div>
  </b-modal>
</template>

<script>
import PrivacyNotice from '../PrivacyNotice.vue'
import config from '../../constants/config';

export default {
  name: 'PrivacyNoticeModal',
  components: {
    PrivacyNotice
  },
  computed: {
    modalId() {
      return config.PRIVACY_NOTICE_MODAL_ID;
    }
  }
};
</script>

<style scoped>
.privacy-modal-card .card {
  box-shadow: none;
}
</style>
